const config = {
  app_name: window.__env.api.app_name,
  base_url: window.__env.api.base_url,
  url: window.__env.api.url,
  log_level: window.__env.api.log_level,
  dev: window.__env.api.dev,
  is_test: window.__env.api.is_test,
  enable_hubspot: window.__env.api.enable_hubspot,
  recaptcha_sitekey: window.__env.api.recaptcha_sitekey,
  hubspot_url: 'https://meetings-eu1.hubspot.com/',
  intercom_app_id: window.__env.api.intercom_app_id,
  datadog_enabled: window.__env.api.datadog_enabled,
  datadog_application_id: window.__env.api.datadog_application_id,
  datadog_client_token: window.__env.api.datadog_client_token,
  datadog_service: window.__env.api.datadog_service,
  datadog_site: window.__env.api.datadog_site,
  datadog_env: window.__env.api.datadog_env,
}

export { config }
